import cn from 'classnames';

import styles from './Progress.module.scss';

interface IProgressProps {
  percent: number | undefined;
  isProgressNumberVisible?: boolean;
  className?: string;
}

export const Progress = ({ percent, isProgressNumberVisible, className }: IProgressProps) => {
  return (
    <div className={cn(styles.Progress, className)}>
      <div className={styles.ProgressBar}>
        <div className={styles.Indicator} style={{ width: `${percent}%` }} />
      </div>
      {isProgressNumberVisible && <div className={styles.ProgressNumber}>{percent}%</div>}
    </div>
  );
};
